// extracted by mini-css-extract-plugin
export default {"tabs_wrapper":"FilterTabs_tabs_wrapper__kal+n"};